import { render, staticRenderFns } from "./CandidateImportDialog.vue?vue&type=template&id=352d27c6&scoped=true"
import script from "./CandidateImportDialog.vue?vue&type=script&lang=js"
export * from "./CandidateImportDialog.vue?vue&type=script&lang=js"
import style0 from "./CandidateImportDialog.vue?vue&type=style&index=0&id=352d27c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d27c6",
  null
  
)

export default component.exports